import { GA_CATEGORIES, GA_ACTIONS } from './config';
import type { GAEvent } from './types';

// Resume builder step events
export const resumeEvents = {
  startBuild: (): GAEvent => ({
    action: GA_ACTIONS.CREATE,
    category: GA_CATEGORIES.RESUME,
    label: 'start_build'
  }),
  
  completeStep: (step: string): GAEvent => ({
    action: GA_ACTIONS.UPDATE,
    category: GA_CATEGORIES.RESUME,
    label: `complete_step_${step}`
  }),

  exitStep: (step: string): GAEvent => ({
    action: GA_ACTIONS.EXIT,
    category: GA_CATEGORIES.RESUME,
    label: `exit_step_${step}`
  }),

  downloadResume: (format: string): GAEvent => ({
    action: GA_ACTIONS.DOWNLOAD,
    category: GA_CATEGORIES.RESUME,
    label: `download_${format}`
  }),

  selectTemplate: (templateId: string): GAEvent => ({
    action: GA_ACTIONS.SELECT,
    category: GA_CATEGORIES.TEMPLATE,
    label: templateId
  })
};

// Session timing events
export const timingEvents = {
  stepDuration: (step: string, duration: number): GAEvent => ({
    action: GA_ACTIONS.TIMING,
    category: GA_CATEGORIES.RESUME,
    label: `duration_${step}`,
    value: duration
  }),

  totalDuration: (duration: number): GAEvent => ({
    action: GA_ACTIONS.TIMING,
    category: GA_CATEGORIES.RESUME,
    label: 'total_duration',
    value: duration
  })
};